import { defineMessages } from 'react-intl';

export default defineMessages({
  formTitle: {
    id: 'recovery_forgot_password.title',
  },
  formSubTitle: {
    id: 'recovery_forgot_password.Question_scrt_form.title',
  },
  questionField: {
    id: 'recovery_forgot_password.Question_scrt_form.question_field',
  },
  responseField: {
    id: 'recovery_forgot_password.Question_scrt_form.response_field',
  },
  valid: {
    id: 'recovery_forgot_password.title_button_valid',
  },
  proceedDifferently: {
    id: 'auth_by_sms.proceed_differently',
  },
  requiredField: {
    id: 'required.field',
  },
  responseError: {
    id: 'recovery_forgot_password.response',
  },
});
